import { urlBuilder } from './builder';

export default urlBuilder(() => '/org-management/');
